export default __webpack_public_path__ + "static/media/three.c2ff5a64.ogg";